import { useMemo } from 'react';
import { useOrderTrackingEvents } from '../models';

export function useTrackingLogs(orderId: string) {
  const { data: trackingEvents } = useOrderTrackingEvents(orderId);

  const sortedEvents = useMemo(() => {
    return (trackingEvents ?? []).sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  }, [trackingEvents]);

  const driverLocation = useMemo(() => {
    if (!trackingEvents) return null;

    let latestEvent = null;

    for (const event of sortedEvents) {
      if (event.latitude != null && event.longitude != null) {
        latestEvent = event;
        break;
      }
    }

    if (latestEvent) {
      return [latestEvent.longitude, latestEvent.latitude] as [number, number];
    } else {
      return null;
    }
  }, [trackingEvents]);

  return {
    trackingEvents: sortedEvents,
    driverLocation,
  };
}
